import React from "react"
import { BrowserRouter as Router, Route, Link } from "react-router-dom"
import "./Transaction.css"
import Card, { TitleCard } from "../core/Card"
import CategoryPicker from "../core/CategoryPicker"
import moment from "moment"
import {
  CategoryIcon,
  FolderIcon,
  ShopIcon,
  NoteIcon,
  CalendarIcon,
  CarIcon,
  Icon,
  BackIcon,
  FromToIcon,
  PlusIcon,
  CrownIcon,
  BriefcaseIcon,
  MarkerIcon,
  ForwardIcon,
  HomeIcon,
  DotIcon
} from "../core/icons"
import {
  Button,
  Switch,
  DatePicker,
  Select,
  Modal,
  Input,
  Icon as AIcon,
  Tooltip,
  Form,
  Alert,
  Popconfirm,
  Row,
  Col
} from "antd"
import numeral from "numeral"
import Uploader from "../core/Uploader"
// import MerchantPicker from './MerchantPicker'
import { Field, reduxForm } from "redux-form"
import SideNav from "../layout/SideNav"
import ScrollToTopOnMount from "../core/ScrollToTopOnMount"

const FormItem = Form.Item

const { Option } = Select
const { TextArea } = Input

const AmountInput = ({
  input,
  meta,
  children,
  hasFeedback,
  label,
  isExpense,
  ...rest
}) => {
  const hasError = meta.touched && meta.invalid
  // const {value, ...newInput} = input
  // newInput.value = value && numeral(value).format('0,0.00');

  return (
    <Tooltip visible={hasError} title={meta.error}>
      <div style={{ textAlign: "center" }}>
        <span
          className={isExpense ? "amount negative" : "amount positive"}
          style={{
            fontWeight: "600",
            fontSize: "40px",
            paddingLeft: "35px"
          }}
        >
          $<input
            {...input}
            // value={numeral(input.value).format('0,0.00')}
            placeholder="0.00"
            {...rest}
            style={{
              border: hasError ? "solid 1px red" : "none",
              width: `${(String(input.value || "0.00").length + 1) * 28}px`,
              minWidth: 100
            }}
          />
        </span>
      </div>
    </Tooltip>
  )
}
const minAmount = amount => (value, previousValue, allValues) =>
  parseFloat(value) >= parseFloat(amount) || !value ? value : previousValue

const maxAmount = amount => (value, previousValue, allValues) =>
  parseFloat(value) <= parseFloat(amount) || !value ? value : previousValue

// ant wrapped redux form examples: https://codesandbox.io/s/JZYL70WpK
const makeField = Component => ({
  formLayout,
  input,
  meta,
  children,
  hasFeedback,
  label,
  ...rest
}) => {
  const hasError = meta.touched && meta.invalid
  return (
    <FormItem
      validateStatus={hasError ? "error" : "success"}
      hasFeedback={hasFeedback && hasError}
      help={hasError && meta.error}
    >
      <Component {...input} {...rest} children={children} />
    </FormItem>
  )
}
const required = value => (value ? undefined : "Required")

const AInput = makeField(Input)
const ASelect = makeField(Select)
const ASwitch = makeField(Switch)
const ATextArea = makeField(TextArea)

const Transaction = ({
  anyTouched,
  isFetching,
  isExpense,
  categorySelectValue,
  onSelectCategory,
  plaid_category,
  plaid_name,
  institution_account_name,
  merchants,
  categories,
  photo,
  onUpload,
  date,
  onDateChange,
  purposeSelectValue,
  onSelectPurpose,
  onDelete,
  error,
  pristine,
  submitting,
  title,
  buttonTitle,
  purposes,
  save
}) => (
  <div className="Transaction">
    <ScrollToTopOnMount />
    <TitleCard className="Title" showBackButton>
      <h1>{title}</h1>
      {anyTouched && error && <Alert message={error} type="error" />}
      <Button
        loading={submitting}
        disabled={pristine}
        onClick={save}
        type="primary"
      >
        {buttonTitle}
      </Button>
      {onDelete && (
        <Popconfirm
          title="Are you sure?"
          placement="left"
          onConfirm={onDelete}
          okText="Yes"
          cancelText="No"
        >
          <Button type="danger" icon="delete" />
        </Popconfirm>
      )}
    </TitleCard>

    {isFetching ? (
      <Card showLoadingIcon={isFetching}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            height: "50vh"
          }}
        />
      </Card>
    ) : (
      <Card className="Content">
        <Row>
          <Col xs={24} sm={12} md={12} className="options">
            <Row type="flex" justify="space-around" align="middle">
              <Field
                name="amount"
                normalize={isExpense ? maxAmount(0) : minAmount(0)}
                component={AmountInput}
                type="number"
                isExpense={isExpense}
                format={(value, name) => value && Math.abs(value)}
                parse={(value, name) => (value && isExpense ? -value : value)}
              />
            </Row>

            {/* <MerchantPicker/> */}
            {merchants && (
              <Row type="flex" align="middle">
                <ShopIcon />
                <Field
                  size="large"
                  name="merchant"
                  component={AInput}
                  placeholder="Merchant..."
                />
              </Row>
            )}

            <Row type="flex" align="middle">
              <CalendarIcon />
              <DatePicker
                size="large"
                value={moment(date, "MMM DD, YYYY")}
                format={"MM-DD-YYYY"}
                onChange={onDateChange}
                allowClear={false}
              />
            </Row>

            <Row align="middle" type="flex">
              <Icon type={purposeSelectValue} selected width="25" height="25" />
              <Select value={purposeSelectValue} onSelect={onSelectPurpose}>
                {purposes.map(purpose => (
                  <Option value={purpose}>
                    <span>{purpose}</span>
                  </Option>
                ))}
              </Select>
            </Row>

            {categories && (
              <Row type="flex" align="middle">
                {categorySelectValue ? (
                  <CategoryIcon
                    type={categorySelectValue}
                    width="25"
                    height="25"
                  />
                ) : (
                  <FolderIcon width="25" />
                )}

                <FormItem>
                  <CategoryPicker
                    onSelect={onSelectCategory}
                    defaultValue={categorySelectValue}
                  />
                </FormItem>
              </Row>
            )}
            <Row type="flex" align="middle">
              <NoteIcon />
              <Field
                name="notes"
                component={ATextArea}
                rows="1"
                autosize
                placeholder="Notes..."
              />
            </Row>
            <Row type="flex" align="space-between">
              {plaid_category &&
                plaid_category[0] && (
                  <div>
                    <h2>Bank Description</h2>
                    {plaid_name}
                    <br />
                    {plaid_category[plaid_category.length - 1]}
                  </div>
                )}

              {institution_account_name && (
                <div>
                  <h2>Bank Account</h2>
                  {institution_account_name}
                </div>
              )}
            </Row>
          </Col>

          <Col xs={24} sm={12} md={12} height="100%">
            <Uploader photo={photo} beforeUpload={onUpload} />
          </Col>
        </Row>
      </Card>
    )}
  </div>
)

export default Transaction



// WEBPACK FOOTER //
// ./src/transactions/Transaction.jsx